import { DLRestrictions } from '../../utils/constants/constants';
import { formData, isCompletelyEmpty, removeEmptyFields, removeEmptyObjects } from '../../utils/data';

const RestrictionTable = ({ restrictions }) => {
  console.log("valid restrictions before:", restrictions)
  removeEmptyFields(restrictions);
  removeEmptyObjects(restrictions);
  console.log("valid restrictions after:", restrictions)
  if (isCompletelyEmpty(restrictions)) return null;
  const isUS = formData.Body.DriverRequest.DriverData.DriverLicense.LicenseCountry === "US";

  return (
    <>
      <th>License Restrictions</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Restriction</th>
            {isUS && <th>End Date</th>}
          </tr>
        </thead>
        <tbody>
          {restrictions.map((item, index) => (
            <tr key={index}>
              <td>{item.RestrictionText || DLRestrictions[item.Code]}</td>
              {isUS && <td>{item.EndDate}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default RestrictionTable;
